import Vue from 'vue';
import App from './index.vue';
import router from './router';
import '../../assets/js/rem';

// 全局消息提醒
import Msg from '../../../src/components/message/config';
import Loading from '../../../src/components/toggleloading/config';
import CM from '@/utils/common';
import ARMS from '@/utils/BrowserLogger.js';
import wxConfigInit from '@/utils/wx-config';
// 公众号配置-全局路由守卫
import directives from  '@mxc/v-directive'
import {lazyLoad} from '@mxc/vue-element';
import registerDirective from '@mxc/v-statistics';

import { Form, Field, ActionSheet, Calendar, Empty } from 'vant';

Vue.use(Form);
Vue.use(Field);
Vue.use(ActionSheet);
Vue.use(Calendar);
Vue.use(Empty);

Vue.use(lazyLoad);
wxConfigInit(router)

registerDirective(Vue, process.env.NODE_ENV === 'production' ? '3ae706ab77147e00a5e1c33f10211159' : '6b2179313c99776c0c0778532ee8cb51')
new directives({vm:Vue})
Vue.use(Msg);
Vue.use(Loading);
Vue.prototype.$CM = CM;
Vue.config.productionTip = false;
// ARMS('miaocode')

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/pages/miaocode/index.js